import React, {useContext, useEffect, useState} from 'react';
import Header from '../components/header';
import AuthContext from "./shared/AuthContext";
import {API} from "../services/api";
import {useNavigate} from "react-router-dom";
import Swal from "sweetalert2";
import {useTranslation} from "react-i18next";
import OrgContext from "../organisation/OrgContext";
import {toast, ToastContainer} from "react-toastify";

const Client = (props) => {
    const [t, i18n] = useTranslation();
    const [display, setDisplay] = useState(false);
    const [displayErrors, setDisplayErrors] = useState('none');
    const {user, logout} = useContext(AuthContext);
    const navigate = useNavigate();
    const { organisation, changeOrg } = useContext(OrgContext);

    const [name, setName] = useState('');
    const [lastName, setLastName] = useState('');
    const [phoneNumber, setPhoneNumber] = useState('');
    const [companyName, setCompanyName] = useState('');
    const [email, setEmail] = useState('');
    const [webSite, setWebSite] = useState('');
    const [ice,setIce] = useState('');
    const [idFiscal,setIdFiscal] = useState('');

    const [facAdCountry, setFacAdCountry] = useState('');
    const [facAdCity, setFacAdCity] = useState('');
    const [facAdCodePostal, setFacAdCodePostal] = useState('');
    const [facAdOthers, setFacAdOthers] = useState('');

    const [livAdCity, setLivAdCity] = useState('');
    const [livAdCountry, setLivAdCountry] = useState('');
    const [livAdCodePostal, setLivAdCodePostal] = useState('');
    const [livAdOthers, setLivAdOthers] = useState('');
    const [isSubmit, setIsSubmit] = useState(false);

    useEffect(()=> {
        if(props.ocr){
            setIce(props.ice);
        }
    }, []);

    const saveClient = async (client) => {
        try {
            setIsSubmit(true);
            const res = await API.post('/client/save', client);
    
            if (props.ocr) {
                props.afterSave(client);
            } else if (props.from === 'new_fv') {
                props.handleSave();
            } else {
                console.log(res);
                const successMessage = 
                    props.type === 'fournisseurs' 
                    ? t('Le fournisseur a été ajouté avec succès') 
                    : t('Le client a été ajouté avec succès');
    
                Swal.fire(successMessage, '', 'success');
                navigate(-1);
            }
        } catch (error) {
            console.error(error);
            Swal.fire(
                t('Erreur'),
                t('Une erreur s’est produite lors de l’ajout. Veuillez réessayer.'),
                'error'
            );
        } finally {
            setIsSubmit(false);
        }
    };
    
    const Save = () => {
        if (idFiscal === '' || email.length === 0 || companyName.length === 0 || phoneNumber.length === 0) {
            toast.error(t('Merci de verifier les champs obligatoire !'), {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: true,
                progress: undefined,
                theme: "colored",
            });
        } else {
            const preparedObject = {
                name: name,
                lastName: lastName === null ? "" : lastName,
                type: props.type,
                email: email,
                companyName: companyName,
                phoneNumber: phoneNumber,
                website: webSite,
                addressFacCountry: facAdCountry,
                addressFacCity: facAdCity,
                addressFacCodePostal: facAdCodePostal,
                addressFacOthers: facAdOthers,
                addressLivCountry: livAdCountry,
                addressLivCity: livAdCity,
                addressLivCodePostal: livAdCodePostal,
                addressLivOthers: livAdOthers,
                user_id: user.id
                ,ice: ice
                ,idFiscalEntreprise: idFiscal
                ,organization_id: organisation.id
            };
            console.log("preparedObject: ", preparedObject)
            saveClient(preparedObject);
        }
    };
    return (
        <>
            <ToastContainer/>

            <div className="row">

                <div className="col-xl-12">
                    <div className="card">
                        <div className="card-header">
                            <div className="card-title">{t('Contact principal')}</div>
                        </div>
                        <div className="card-body">
                            <div className="form-group">
                                <label htmlFor="exampleInputEmail1" className="">{t('Nom de la société')}*</label>
                                <input type="text" className={`form-control`}
                                       onChange={(e) => setCompanyName(e.target.value)} value={companyName}
                                />
                            </div>
                            <div className="form-group">
                                <label htmlFor="exampleInputEmail1" className="">{t('Nom Complete Du Contact')}</label>
                                <input onChange={(e) => setName(e.target.value)} value={name} type="text"
                                       placeholder="nom" className={`form-control `}
                                />
                            </div>
                            <div className="form-group">
                                <label htmlFor="exampleInputEmail1" className="">{t('E-mail du')} { props.type=== 'fournisseurs' ? t('fournisseur') : t('client') }*</label>
                                <input type="email"
                                       placeholder="" className={`form-control`}
                                       onChange={(e) => setEmail(e.target.value)} value={email}
                                />
                            </div>
                            <div className="form-group">
                                <label htmlFor="exampleInputEmail1" className="">{t('Téléphone du')} { props.type=== 'fournisseurs' ? t('fournisseur') : t('client') }*</label>
                                <input type="tel" className={`form-control`}
                                       onChange={(e) => setPhoneNumber(e.target.value)} value={phoneNumber}
                                />
                            </div>
                            <div className="form-group">
                                <label htmlFor="exampleInputEmail1" className="">{t('Site Internet')}</label>
                                <input type="text" className={`form-control`}
                                       onChange={(e) => setWebSite(e.target.value)} value={webSite}
                                />
                            </div>
                            <div className="form-group">
                                <label htmlFor="exampleInputEmail1" className="">{t("L'identifiant Commun de l'Entreprise")} *</label>
                                <input type="text" className={`form-control`}
                                       onChange={(e) => setIce(e.target.value)} value={ice}
                                />
                            </div>

                            <div className="form-group">
                                <label htmlFor="exampleInputEmail1" className="">{t("L'identifiant Fiscal de L'entreprise")} *</label>
                                <input type="text" className={`form-control`}
                                       onChange={(e) => setIdFiscal(e.target.value)} value={idFiscal}
                                />
                            </div>
                        </div>
                    </div>

                    <div className="card">
                        <div className="card-header">
                            <h3 className="card-title">{t('ADRESSE DE FACTURATION')}</h3>
                        </div>
                        <div className="card-body">
                            <div className="row">
                                <div className="col-lg-6 col-md-12">
                                    <div className="form-group">
                                        <label htmlFor="exampleInputname" className=""></label>
                                        <div className="input-group mb-3">
                                            <span className="input-group-text">{t('Pays / Région')} </span>
                                            <input type="text" className={`form-control`}
                                                   onChange={(e) => setFacAdCountry(e.target.value)}
                                                   value={facAdCountry}
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-6 col-md-12">
                                    <div className="form-group">
                                        <label htmlFor="exampleInputname1" className={``}>{t('Ville')} </label>
                                        <input type="text" className={`form-control`}
                                               onChange={(e) => setFacAdCity(e.target.value)} value={facAdCity}/>
                                    </div>
                                </div>

                                <div className="col-lg-6 col-md-12">
                                    <div className="form-group">
                                        <label htmlFor="exampleInputname" className=""></label>
                                        <div className="input-group mb-3">
                                            <span className="input-group-text">{t('Code postal')} </span>
                                            <input type="number" className={`form-control`}
                                                   onChange={(e) => setFacAdCodePostal(e.target.value)}
                                                   value={facAdCodePostal}/>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-6 col-md-12">
                                    <div className="form-group">
                                        <label htmlFor="exampleInputname1" className={``}>{t('Adresse | Rue 1 | Rue 2')}</label>
                                        <textarea onChange={(e) => setFacAdOthers(e.target.value)} value={facAdOthers}
                                                  className="form-control" rows="3" defaultValue=''></textarea>
                                    </div>
                                </div>
                                <div className="col-lg-6 col-md-12">
                                    <div className="form-group">
                                        <label className="custom-control custom-radio">
                                            <input type="checkbox" className="custom-control-input"
                                                   name="example-radios"
                                                   value="option1" onChange={(e) => setDisplay(!display)}/>
                                            <span className="custom-control-label">{t("Utiliser l'addresse de facturation comme adresse de livraison")}</span>
                                        </label>
                                    </div>
                                </div>
                            </div>
                            {/*<div className="form-group">*/}
                            {/*    <label htmlFor="exampleInputEmail1">Taxe</label>*/}
                            {/*    <div className="input-group mb-3">*/}
                            {/*        <select className="form-select" id="inputGroupSelect01">*/}
                            {/*            <option selected>Séléctionnez une taxe</option>*/}
                            {/*            <option value="1">One</option>*/}
                            {/*            <option value="2">Two</option>*/}
                            {/*            <option value="3">Three</option>*/}
                            {/*        </select>*/}
                            {/*    </div>*/}
                            {/*</div>*/}
                        </div>
                    </div>

                    <div className="card" style={{display: (display) ? 'none' : 'block'}}>
                        <div className="card-header">
                            <h3 className="card-title">{t('ADRESSE DE LIVRAISON')}</h3>
                        </div>
                        <div className="card-body">
                            <div className="row">
                                <div className="col-lg-6 col-md-12">
                                    <div className="form-group">
                                        <label htmlFor="exampleInputname" className=""></label>
                                        <div className="input-group mb-3">
                                            <span className="input-group-text">{('Pays / Région')} </span>
                                            <input type="text" className={`form-control`}
                                                   onChange={(e) => setLivAdCountry(e.target.value)}
                                                   value={livAdCountry}
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-6 col-md-12">
                                    <div className="form-group">
                                        <label htmlFor="exampleInputname1" className={``}>{t('Ville')} </label>
                                        <input type="text" className={`form-control`}
                                               onChange={(e) => setLivAdCity(e.target.value)} value={livAdCity}/>
                                    </div>
                                </div>

                                <div className="col-lg-6 col-md-12">
                                    <div className="form-group">
                                        <label htmlFor="exampleInputname" className=""></label>
                                        <div className="input-group mb-3">
                                            <span className="input-group-text">{t('Code postal')} </span>
                                            <input type="number" className={`form-control`}
                                                   onChange={(e) => setLivAdCodePostal(e.target.value)}
                                                   value={livAdCodePostal}
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-6 col-md-12">
                                    <div className="form-group">
                                        <label htmlFor="exampleInputname1" className={``}>{t('Adresse | Rue 1 | Rue 2')} </label>
                                        <textarea className="form-control" rows="3" defaultValue=''
                                                  onChange={(e) => setLivAdOthers(e.target.value)}
                                                  value={livAdOthers}></textarea>
                                    </div>
                                </div>
                            </div>
                            {/*<div className="form-group">*/}
                            {/*    <label htmlFor="exampleInputEmail1">Taxe</label>*/}
                            {/*    <div className="input-group mb-3">*/}
                            {/*        <select className="form-select" id="inputGroupSelect01">*/}
                            {/*            <option selected>Séléctionnez une taxe</option>*/}
                            {/*            <option value="1">One</option>*/}
                            {/*            <option value="2">Two</option>*/}
                            {/*            <option value="3">Three</option>*/}
                            {/*        </select>*/}
                            {/*    </div>*/}
                            {/*</div>*/}
                        </div>

                    </div>
                    <div className="card">
                        <div className="card-footer">
                            <div className="row">

                                <div className="col-md-12">
                                    <button disabled={isSubmit} type="button" className="btn btn-primary"
                                       onClick={Save}>{isSubmit ? t("Loading ...") : t("Enregistrer")}</button>
                                    {props.ocr ? null : (<a 
                                        onClick={()=>{
                                            navigate(-1);
                                        }}
                                        className="btn btn-default float-end"
                                        style={{display: props.from === 'new_fv' ? 'none' : 'block'}}>{t('Annuler')}</a>)}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default Client;